import React from "react";
import { Routes, Route } from "react-router-dom";

import List from "./list";
import View from "./view";

export default function JobAds() {
  return (
    <Routes>
      <Route index element={<List />} />
      <Route path=":id/*" element={<View />} />
    </Routes>
  );
}
